module.exports = __webpack_public_path__ + "img/horizontal_4_1_pp1_5012.dd5ffc41.png";